exports.cs = {
  UNIFORM_OW_INPUT_TEL: {
    INVALID_INPUT: 'Pole není vyplněno správně.',
    INVALID_FORMAT: 'Zadali jste špatný formát telefonního čísla.',
    ERROR_REQUIRED: 'Zadejte prosím požadované údaje.',
    ARIA_LABEL: 'Telefonní číslo'
  }
}
